export default __webpack_public_path__ + "static/media/email-login-banner.f0318889.png";